import { render, staticRenderFns } from "./deductionDetail-travel.vue?vue&type=template&id=321efcee&scoped=true"
import script from "./deductionDetail-travel.vue?vue&type=script&lang=js"
export * from "./deductionDetail-travel.vue?vue&type=script&lang=js"
import style0 from "./deductionDetail-travel.vue?vue&type=style&index=0&id=321efcee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321efcee",
  null
  
)

export default component.exports